import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ImageBox = styled(Box)(({ theme: { spacing } }) => ({
  height: spacing(7),
  minWidth: spacing(20),
  marginRight: spacing(1.6),
  display: 'flex',
  alignItems: 'center',
  '& img': {
    width: '100%',
    height: '100%',
  },
}));
